import http from "./interceptors";
import { aes128Encrypt } from "@/utils/aes128.js";

export function getMethod(url, params) {
  // console.log("params", params);
  return http({
    url: url,
    method: "get",
    params: params,
  });
}

export function postMethodEncrypt(url, params) {
  // console.log("params", params);
  return http({
    headers: {
      "Content-Type": "application/json",
    },
    url: url,
    method: "post",
    data: {
      data: aes128Encrypt(params),
    },
  });
}
